import { GetDeviceConfigurationResponse } from 'core/api';
import { Events } from 'core/infrastructure';
import * as BridgeProxy from './BridgeProxy';
import { Endpoints } from './BridgeProxy.Endpoints';
import { fixTouchEvents } from './Electron.FixTouchEvents';
type ElectronType = typeof import('../../../../desktop-pos/src/preload-core');

const isEnabled = (window as any).electron !== undefined;

const Electron: ElectronType & { isEnabled(): boolean, close: () => void, configure: (configuration: GetDeviceConfigurationResponse, startCashControl: () => void) => Promise<void> } = {
	...(window as any).electron
};

Electron.isEnabled = () => isEnabled;
Electron.close = () => isEnabled && window.close();

Electron.configure = async (configuration: GetDeviceConfigurationResponse, startCashControl: () => void) => {

	if (!isEnabled)
		return;

	if (configuration.UseCashControl)
		startCashControl();

	if (await Electron.Settings.shouldFixTouchEvents())
		fixTouchEvents(Electron.Window.sendInputEvent);

	Events.on('language:changed', async languageCode => {
		await BridgeProxy.invoke('NO_REGISTER_USER_ACTIVITY', Endpoints.Environment.SetLanguageCode, { languageCode: languageCode });
	});
};


export default Electron;

